import { render, staticRenderFns } from "./CookieSettingsForm.vue?vue&type=template&id=1c856c8c"
import script from "./CookieSettingsForm.vue?vue&type=script&lang=js"
export * from "./CookieSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports